var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSExh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 40,
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 9.16344 11.1634 2 20 2H73C81.8366 2 89 9.16344 89 18C89 26.8366 81.8366 34 73 34H20C11.1634 34 4 26.8366 4 18Z",
    fill: "#282D4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.217 11.314V14.525H40.877V15.396H43.217V19.855H44.296V11.314H43.217ZM41.033 18.1L41.566 17.268C39.876 16.683 38.732 15.201 38.732 13.693V13.121H41.293V12.25H35.066V13.121H37.666V13.706C37.666 15.357 36.457 16.904 34.728 17.528L35.287 18.36C36.652 17.853 37.718 16.813 38.225 15.461C38.732 16.657 39.733 17.632 41.033 18.1ZM44.621 22.702V21.831H37.913V19.101H36.834V22.702H44.621ZM55.19 22.988V11.301H54.124V22.988H55.19ZM49.782 14.408V12.315H48.729V14.408C48.729 16.644 47.299 18.841 45.596 19.673L46.246 20.544C47.611 19.816 48.729 18.412 49.262 16.631C49.821 18.308 50.913 19.66 52.265 20.323L52.902 19.465C51.186 18.698 49.782 16.54 49.782 14.408ZM66.149 22.988V11.301H65.083V22.988H66.149ZM60.741 14.408V12.315H59.688V14.408C59.688 16.644 58.258 18.841 56.555 19.673L57.205 20.544C58.57 19.816 59.688 18.412 60.221 16.631C60.78 18.308 61.872 19.66 63.224 20.323L63.861 19.465C62.145 18.698 60.741 16.54 60.741 14.408ZM73.559 14.291H76.094V17.333H77.173V11.314H76.094V13.42H73.559V14.291ZM73.832 17.086L74.378 16.254C72.701 15.695 71.518 14.291 71.518 12.757V11.678H70.465V12.757C70.465 14.434 69.308 15.929 67.553 16.514L68.112 17.359C69.477 16.852 70.517 15.838 71.024 14.525C71.531 15.721 72.532 16.631 73.832 17.086ZM77.615 22.806V21.961H70.738V20.713H77.173V17.918H69.659V18.763H76.12V19.907H69.685V22.806H77.615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 18.57C23.6439 18.57 22.0001 20.2139 22.0001 22.2367C24.0228 22.2367 25.6667 20.5928 25.6667 18.57ZM18.3334 18.57C18.3334 20.5928 19.9773 22.2367 22.0001 22.2367C22.0001 20.2139 20.3562 18.57 18.3334 18.57ZM19.5556 17.3661C19.5556 17.8917 19.9834 18.3194 20.5089 18.3194C20.7106 18.3194 20.8939 18.2583 21.0528 18.1483L21.0467 18.2217C21.0467 18.7472 21.4745 19.175 22.0001 19.175C22.5256 19.175 22.9534 18.7472 22.9534 18.2217L22.9473 18.1483C23.1001 18.2522 23.2895 18.3194 23.4912 18.3194C24.0167 18.3194 24.4445 17.8917 24.4445 17.3661C24.4445 16.9872 24.2184 16.6572 23.9006 16.5044C24.2184 16.3578 24.4445 16.0278 24.4445 15.6489C24.4445 15.1233 24.0167 14.6956 23.4912 14.6956C23.2895 14.6956 23.1062 14.7567 22.9473 14.8667L22.9534 14.7933C22.9534 14.2678 22.5256 13.84 22.0001 13.84C21.4745 13.84 21.0467 14.2678 21.0467 14.7933L21.0528 14.8667C20.9001 14.7567 20.7106 14.6956 20.5089 14.6956C19.9834 14.6956 19.5556 15.1233 19.5556 15.6489C19.5556 16.0278 19.7817 16.3578 20.0995 16.5106C19.7817 16.6572 19.5556 16.9872 19.5556 17.3661ZM22.0001 15.5511C22.5256 15.5511 22.9534 15.9789 22.9534 16.5044C22.9534 17.03 22.5256 17.4578 22.0001 17.4578C21.4745 17.4578 21.0467 17.03 21.0467 16.5044C21.0467 15.9789 21.4745 15.5511 22.0001 15.5511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 11.8333H28.1667V24.1667H15.8334V11.8333ZM16.8334 12.8333V23.1667H27.1667V12.8333H16.8334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2918",
    x: 0,
    y: 0,
    width: 93,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2918",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSExh);
export default __webpack_public_path__ + "static/media/s_exh.bd69d31957dfaa19872463216ea03d87.svg";
export { ForwardRef as ReactComponent };